import React from "react";
import {BASE_URL_FILE} from "../../../../env_config";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment-timezone";
import { FaExclamationTriangle } from "react-icons/fa";

// function jugaadDate(x) {
//     // const tempDateNew = moment.tz(x, "America/St_Johns").format("YYYY-MM-DD HH:mm:ss");
//     // const dateNew = moment.tz(tempDateNew, "America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss");
//     // return dateNew

//     let storedDate = new Date(x);
//     storedDate = new Date(storedDate.getTime() - (330 * 60 * 1000));
//     return storedDate
// }

export const InvalidDiamondColumn = (userinfo,editPerm,subId) => {
    let array = [
    {
        Header: "Date and Time",
        // accessor: "createdDate",
        accessor: (d) => {
            return (
                <>
                    {/* {  d.createdDate ? moment.tz(d.createdDate, "Etc/GMT").format("YYYY-MM-DD HH:mm:ss") : "-"} */}
                    {  d.createdDate ? d.createdDate : "-"}
                </>
            );
        },
        className: "text-center text-nowrap align-middle",
    },
    {
        Header: "File Name",
        accessor: "info",
        minwidth: 50,
        className: "text-center align-middle",
        Cell: (row) => {
            return (
                <>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip >{row.row.original.info}</Tooltip>} >
                            <span className="text-truncate d-inline-block" style={{ maxWidth: "80px" }}>{row.row.original.info}</span>
                        </OverlayTrigger>
                </>
            )
        }
    },
    {
        Header: "Upload Type",
        accessor: "uploadType",
        className: "text-center align-middle",
    },
    {
        Header: "Account Status",
        accessor: (d) => {
            return (
                <>
                   {d.stockStatus === "LIVE"?<span className="text-success">{d.stockStatus}</span>
                   :d.stockStatus === "Expired"?<span className="text-danger">{d.stockStatus}</span>
                   :d.stockStatus === "Freeze"?<span className="text-danger">{d.stockStatus}</span>
                   :d.stockStatus === "InActive"?<span className="text-danger">{d.stockStatus}</span>
                   :d.stockStatus === "Error"?<span className="text-danger">{d.stockStatus}</span>
                   :""}
                </>
            );
        },
        className: "text-center align-middle",
    },
    {
        Header: "Stock Status",
        accessor: (d) => {
            return (
                <>
                   {<span className="text-danger">{d.status}</span>}
                </>
            );
        },
        className: "text-center align-middle",
    },
    {
        Header: "Error Reason",
        accessor: "error_reason",
        minwidth: 50,
        className: "text-center align-middle",
        Cell: (row) => {
            return (
                <>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip >{row.row.original.error_reason}</Tooltip>} >
                            <span className="text-truncate d-inline-block" style={{ maxWidth: "100px" }}>{row.row.original.error_reason}</span>
                        </OverlayTrigger>
                </>
            )
        }
    }
    
]
if(userinfo.uploadMode === "custom API"){
    array = array.filter(value => value.Header !== "File Name")
}
return array
};
